<template>
    <div>
        <div class="mt-1 rounded-md shadow-sm focus-within:shadow-outline-blue">
            <div class="relative flex">
                <div class="flex-grow">
                    <input v-model="displayValue"
                           class="form-input block w-full sm:leading-5 rounded-r-none h-full focus:outline-none focus:shadow-none focus:border-gray-300"
                           @input="updateValues($event)"
                           @keydown.enter.prevent="lookupVoucher"
                    />
                </div>
                <button type="button"
                        class="-ml-px flex-shrink-0 relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-semibold rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none"
                        @click.enter.prevent="lookupVoucher"
                >
                    <span>Apply Voucher</span>
                </button>
            </div>
        </div>
        <p class="mt-1 text-xs text-red-600" v-if="hasError('code')">
            {{ getErrorFor('code') }}
        </p>

        <portal to="modal">
            <modal v-if="voucher"
                   @hide="clearVoucher"
            >
                <template v-slot:default="props">
                    <div class="text-center font-josefin" v-if="voucher">
                        <h2 class="text-xl sm:text-2xl mb-3">Apply Voucher</h2>
                        <p class="text-2xl sm:text-4xl font-josefin text-primary-600">
                            {{ voucher.hyphenated_code }}
                        </p>
                        <p class="text-2xl sm:text-3xl">
                            £{{ voucher.formatted_amount }}
                        </p>
                    </div>

                    <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                        <span class="flex w-full rounded-md shadow-sm sm:col-start-2">
                            <form-button class="w-full"
                                         @click.native="applyVoucher(props.hide)"
                            >
                                Apply to my Account
                            </form-button>
                        </span>

                        <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:col-start-1">
                            <form-button colour="white"
                                         class="w-full"
                                         @click.native="props.hide()"
                            >
                                Cancel
                            </form-button>
                        </span>
                    </div>
                </template>
            </modal>
        </portal>
    </div>
</template>

<script>
    import Modal from "../Modal";
    import FormButton from "./Button";

    export default {
        data() {
            return {
                displayValue: '',
                actualValue: '',

                errors: {},

                voucher: null,
            }
        },

        components: { Modal, FormButton },

        watch: {
            actualValue: function (value) {
                this.$emit('input', value);
            }
        },

        methods: {
            updateValues(e) {
                this.actualValue = e.target.value.replace(/[^a-zA-Z0-9]/g, '').substr(0,16);

                let displayValue = this.actualValue.match(/.{1,4}/g);

                this.displayValue = displayValue ? displayValue.join(' - ') : this.actualValue;
            },

            lookupVoucher() {
                axios.post('/lookup-voucher', { code: this.actualValue })
                    .then(response => {
                        this.voucher = response.data;
                    }).catch(errors => {
                        this.errors = errors.response.data.errors
                    });
            },

            applyVoucher(hide) {
                axios.post('/redeem-voucher', { code: this.actualValue })
                    .then(response => {
                        hide();
                        this.$emit('voucher-applied', response.data.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}));
                    }).catch(errors => {
                        hide();
                        this.errors = errors.response.data.errors
                    })
            },

            clearVoucher() {
                this.voucher = null;
                this.actualValue = '';
                this.displayValue = '';
            },

            /**
             * Check if the given field has an error
             * @param field
             * @return {boolean}
             */
            hasError(field) {
                return _.has(this.errors, field);
            },

            /**
             * Get the error for the field
             * @param field
             */
            getErrorFor(field) {
                return this.hasError(field) ? this.errors[field][0] : '';
            },
        }
    }
</script>
